/**
 * Where swisstopo's tile and image services live. Production uses the public hosts; the offline
 * e2e points both at a local stub so no test depends on the internet.
 */
const trim = (s: string) => s.replace(/\/+$/, "");

export const wmtsBase = (): string =>
  trim(import.meta.env.VITE_WMTS_BASE ?? "https://wmts.geo.admin.ch");

export const wmsBase = (): string =>
  trim(import.meta.env.VITE_WMS_BASE ?? "https://wms.geo.admin.ch");
